import React from 'react'
import Category from './Category'

function Product1() {
  return (
    <div><Category/></div>
  )
}

export default Product1